<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      clipped
      :expand-on-hover="
        this.$vuetify.breakpoint.lg ||
        this.$vuetify.breakpoint.md ||
        this.$vuetify.breakpoint.xl
      "
      :mini-variant="this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.md || this.$vuetify.breakpoint.xl"
      class="sidebar-gradient"
      app
      transition="fade-transition"
      v-if="usuarioLogado"
    >
      <v-list
        dense
        v-if="companyobj.logoUrl"
        class="py-3 logo-container"
        style="padding: 15px"
        :color="companyobj.bgLogoMenu ? companyobj.bgLogoMenu : 'white'"
      >
        <v-img
          :src="companyobj.logoUrl"
          max-width="-webkit-fill-available;"
          class="logo-image"
        ></v-img>
      </v-list>

      <v-list dense class="py-2 menu-list">
        <v-list-item
          to="/home"
          @click="textoMenu = 'Dashboard'"
          active-class="menu-item-active"
          class="menu-item"
          data-title="Dashboard"
        >
          <v-list-item-action>
            <v-icon dense medium class="menu-icon">dashboard</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="menu-title">Dashboard</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          v-if="
            (companyobj.vigilante && user.tipo == 'ADMIN') ||
            (companyobj.vigilante && user.tipo == 'GERENTE')
          "
          to="/vigilantes"
          active-class="menu-item-active"
          class="menu-item"
          @click="textoMenu = 'Vigilantes'"
          data-title="Vigilantes"
        >
          <v-list-item-action>
            <v-icon dense medium class="menu-icon">security</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="menu-title">Vigilantes</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          v-if="
            (companyobj.vigilante && user.tipo == 'ADMIN') ||
            (companyobj.vigilante && user.tipo == 'GERENTE')
          "
          to="/convocacao"
          active-class="menu-item-active"
          class="menu-item"
          @click="textoMenu = 'Convocação'"
        >
          <v-list-item-action>
            <v-icon dense medium class="menu-icon">person</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="menu-title">Convocação</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          to="/empresas"
          v-if="(!companyobj.vigilante && user.tipo == 'ADMIN')"
          @click="textoMenu = 'Empresas'"
          active-class="menu-item-active"
          class="menu-item"
          data-title="Empresas"
        >
          <v-list-item-action>
            <v-icon dense medium class="menu-icon">business</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="menu-title">Empresas</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-group
          nav
          dense
          value="true"
          class="menu-group"
          v-if="
            (!companyobj.vigilante && user.tipo == 'ADMIN') ||
            (!companyobj.vigilante && user.tipo == 'GERENTE') ||
            (!companyobj.vigilante && user.tipo == 'NOTIFY')
          "
        >
          <template v-slot:activator>
            <v-list-item-action>
              <v-icon dense medium class="menu-icon">folder</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="menu-title">Eventos</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item to="/eventos" class="submenu-item">
            <v-list-item-action>
              <v-icon class="submenu-icon">add_circle</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="submenu-title">Cadastrar</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item to="/mapa" class="submenu-item">
            <v-list-item-action>
              <v-icon class="submenu-icon">mdi-map</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="submenu-title">Mapa do Evento</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-group
          v-if="
            (companyobj.vigilante && user.tipo == 'ADMIN')
          "
          nav
          dense
          class="menu-group"
        >
          <template v-slot:activator>
            <v-list-item-action>
              <v-icon dense medium class="menu-icon">settings</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="menu-title">Configurações</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item to="/criaqrcode" active-class="menu-item-active" class="submenu-item">
            <v-list-item-action>
              <v-icon dense medium class="submenu-icon">qr_code edit</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="submenu-title">Cadastrar QR Code</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-item
          to="/agenda"
          active-class="menu-item-active"
          class="menu-item"
          @click="textoMenu = 'Agenda'"
          v-if="companyobj.agenda"
        >
          <v-list-item-action>
            <v-icon dense medium class="menu-icon">event</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="menu-title">Agenda</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          v-if="!companyobj.vigilante"
          to="/inscricoes"
          active-class="menu-item-active"
          class="menu-item"
          @click="textoMenu = 'Inscrições'"
        >
          <v-list-item-action>
            <v-icon dense medium class="menu-icon">assignment_turned_in</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="menu-title">Inscrições</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-group
          nav
          dense
          class="menu-group"
          v-if="
            (!companyobj.vigilante && user.tipo == 'ADMIN') ||
            (!companyobj.vigilante && user.tipo == 'GERENTE') ||
            (!companyobj.vigilante && user.tipo == 'NOTIFY')
          "
        >
          <template v-slot:activator>
            <v-list-item-action>
              <v-icon class="menu-icon">person</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="menu-title">Divulgador</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item to="/divulgador" class="submenu-item">
            <v-list-item-action>
              <v-icon class="submenu-icon">add_circle</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="submenu-title">Cadastrar</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item to="/listaindicacoes" class="submenu-item">
            <v-list-item-action>
              <v-icon class="submenu-icon">group</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="submenu-title">Indicações</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-item v-if="user.tipo == 'NOTIFY'" to="/whatsapp" class="menu-item" active-class="menu-item-active">
          <v-list-item-action>
            <v-icon class="menu-icon">mdi-whatsapp</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="menu-title">Enviar Whatsapp</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="user.tipo == 'ADMIN'" to="/usuarios" class="menu-item" active-class="menu-item-active">
          <v-list-item-action>
            <v-icon class="menu-icon">mdi-account-group</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="menu-title">Usuários</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          v-if="
            (companyobj.vigilante && user.tipo == 'ADMIN')
          "
          to="/associarqrcode"
          active-class="menu-item-active"
          class="menu-item"
          @click="textoMenu = 'Associar QRCode'"
        >
          <v-list-item-action>
            <v-icon dense medium class="menu-icon">qr_code</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="menu-title">Associar QRCode</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          v-if="
            (companyobj.vigilante && user.tipo == 'ADMIN')
          "
          to="/associarqrcodecheckin"
          active-class="menu-item-active"
          class="menu-item"
          @click="textoMenu = 'Associar QRCode/Check-in'"
        >
          <v-list-item-action>
            <v-icon dense medium class="menu-icon">qr_code</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="menu-title">Associar QRCode/Check-in</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          v-if="
            (companyobj.vigilante && user.tipo == 'ADMIN') ||
            !user.tipo == 'CHECKIN'
          "
          to="/checkin"
          active-class="menu-item-active"
          class="menu-item"
          @click="textoMenu = 'Check-in'"
        >
          <v-list-item-action>
            <v-icon dense medium class="menu-icon">assignment_turned_in</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="menu-title">Check-in</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          v-if="
            (companyobj.vigilante && user.tipo == 'ADMIN') ||
            user.tipo == 'CHECKOUT'
          "
          to="/checkout"
          active-class="menu-item-active"
          class="menu-item"
          @click="textoMenu = 'Check-out'"
        >
          <v-list-item-action>
            <v-icon dense medium class="menu-icon">assignment</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="menu-title">Check-out</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <template v-slot:append>
        <div class="menu-footer">
          <v-list-item href='https://wa.me/558335125222' target="_blank" active-class="menu-item-active" class="support-item">
          <v-list-item-action>
              <v-avatar size="32" class="support-avatar">
                <img src="../assets/icon-suporte-fechado.png" alt="Suporte">
              </v-avatar>
          </v-list-item-action>
          <v-list-item-content>
              <v-list-item-title class="menu-title">Suporte</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        </div>
      </template>

    </v-navigation-drawer>

    <v-app-bar
      app
      clipped-left
      color="white"
      elevation="1"
      v-if="usuarioLogado"
      class="app-header"
    >
      <v-app-bar-nav-icon
        @click.stop="drawer = !drawer"
        color="grey darken-2"
      ></v-app-bar-nav-icon>

      <v-toolbar-title class="title-text">{{ textoMenu }}</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon class="mr-2" @click="toggleDarkMode">
        <v-icon color="grey darken-2">{{ darkMode ? 'mdi-weather-sunny' : 'mdi-weather-night' }}</v-icon>
      </v-btn>

      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-avatar color="grey lighten-4" size="36">
              <v-icon color="grey darken-2">mdi-account</v-icon>
            </v-avatar>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item>
            <v-list-item-avatar>
              <v-img v-if="user.imagem != ''" :src="user.imagem"></v-img>
              <v-icon v-else large light>account_circle</v-icon>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title style="font-weight: bold; color: grey">{{
                user.nome
              }}</v-list-item-title>
              <v-list-item-subtitle>{{ companyobj.nome }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-divider></v-divider>

          <v-list-item @click.stop="teste()">
            <v-list-item-title>Editar usuário</v-list-item-title>
          </v-list-item>
          <v-list-item @click.stop="teste()">
            <v-list-item-title>Alterar senha</v-list-item-title>
          </v-list-item>
          <v-list-item @click.stop="teste()">
            <v-list-item-title>Enviar sugestão</v-list-item-title>
          </v-list-item>

          <v-divider></v-divider>

          <v-list-item @click="Sair()">
            <v-list-item-title>Sair</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    source: String,
  },
  data() {
    return {  
      company: [],
      /* user: [], */
      textoMenu: "Dashboard",
      drawer: null,
      items: [
        { title: "Home", icon: "dashboard" },
        { title: "About", icon: "question_answer" },
      ],
      clipped: true,
      mini: false,
      right: null,
      title: "Controle de Clientes",
      darkMode: false,
    };
  },
  
  

  created() {
    //this.$vuetify.theme.dark = false
  },

  mounted: function () {
    if (sessionStorage.getItem("accToken") != null)
      this.$store.dispatch("Logar", this.token);
    if (sessionStorage.getItem("user") != null) this.$store.dispatch("SetUser");
    if (sessionStorage.getItem("company") != null)
      this.$store.dispatch("SetCompany");
    // Recuperar a preferência do usuário se existir
    const savedDarkMode = localStorage.getItem('darkMode');
    if (savedDarkMode) {
      this.darkMode = savedDarkMode === 'true';
      this.$vuetify.theme.dark = this.darkMode;
      this.$emit('dark-mode-changed', this.darkMode);
    }
  },

  computed: mapState({
    usuarioLogado: (state) => state.isMenuVisible,
    user: (state) => state.userObj,
    companyobj: (state) => state.companyObj,
  }),

  methods: {
    Sair() {
      this.$store.dispatch("Sair");
      this.$router.push({ path: "/login" });
    },

    menuListaCli() {
      this.$router.push({ path: "/lista" });
    },

    menuListaAtend() {
      this.$router.push({ path: "/tipoatend" });
    },

    menuSair() {
      this.$router.push({ path: "/" });
    },

    menuPainels() {
      this.$router.push({ path: "/paineis" });
    },
    toggleDarkMode() {
      this.darkMode = !this.darkMode;
      this.$vuetify.theme.dark = this.darkMode;
      this.$emit('dark-mode-changed', this.darkMode);
      // Se quiser salvar a preferência do usuário
      localStorage.setItem('darkMode', this.darkMode ? 'true' : 'false');
    },
  },
};
</script>

<style scoped>
.sidebar-gradient {
  background: linear-gradient(145deg, #6a11cb, #2575fc);
  border-radius: 0 24px 24px 0;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
  overflow: hidden;
}

.sidebar-gradient::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at top right, rgba(255, 255, 255, 0.1) 0%, transparent 60%);
  pointer-events: none;
}

.sidebar-gradient::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    radial-gradient(circle at bottom left, rgba(0, 0, 0, 0.1) 0%, transparent 60%),
    linear-gradient(to bottom, rgba(255, 255, 255, 0.05) 0%, transparent 70%);
  pointer-events: none;
}

.v-navigation-drawer.v-navigation-drawer--open:not(.v-navigation-drawer--mini-variant) {
  width: 280px !important;
}

.logo-container {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  margin-bottom: 12px;
}

.logo-image {
  transition: all 0.3s ease;
  filter: drop-shadow(0px 2px 6px rgba(0, 0, 0, 0.2));
}

.menu-list {
  padding: 8px 12px;
}

.menu-item {
  border-radius: 8px;
  margin-bottom: 4px;
  transition: all 0.3s ease;
}

.menu-item:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.menu-item-active {
  background: rgba(255, 255, 255, 0.2) !important;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.15);
}

.menu-icon {
  color: rgba(255, 255, 255, 0.9) !important;
  transition: all 0.3s ease;
}

.menu-title {
  color: rgba(255, 255, 255, 0.9) !important;
  font-weight: 400;
  letter-spacing: 0.5px;
  word-wrap: break-word;
  font-size: 0.95rem;
}

.menu-item:hover .menu-icon, 
.menu-item-active .menu-icon {
  color: white !important;
  transform: scale(1.1);
}

.menu-item:hover .menu-title, 
.menu-item-active .menu-title {
  color: white !important;
  font-weight: 500;
}

.v-list-group__header .v-list-item__icon {
  color: rgba(255, 255, 255, 0.9) !important;
}

.v-list-group__header .v-list-item__title {
  color: rgba(255, 255, 255, 0.9) !important;
  font-weight: 400;
  letter-spacing: 0.5px;
}

.v-list-group__header.v-list-item--active {
  background-color: rgba(255, 255, 255, 0.1) !important;
}

.v-list-item__icon {
  margin: 12px !important;
}

.corMenu {
  display: none !important;
}

.app-header {
  background: white;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.05) !important;
  transition: all 0.3s ease;
}

.theme--dark .app-header {
  background: #1e1e1e !important;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.2) !important;
}

.title-text {
  font-size: 1.1rem;
  font-weight: 600;
  letter-spacing: 0.5px;
  color: #333;
  margin-left: 8px;
}

.theme--dark .title-text {
  color: #fff;
}

.theme--dark .v-icon {
  color: rgba(255, 255, 255, 0.9) !important;
}

.v-app-bar-nav-icon {
  transition: all 0.3s ease;
}

.v-app-bar-nav-icon:hover {
  transform: scale(1.1);
}

.app-header .v-btn {
  transition: all 0.3s ease;
}

.app-header .v-btn:hover {
  transform: translateY(-2px);
}

.imagemLogo {
  position: absolute;
  right: 50%;
  left: 50%;
  margin-right: -50px;
  margin-left: -50px;
}

.textomenu {
  font-size: 15px;
  position: absolute;
  left: 5%;
  color: white;
  /* margin-right:-50px; */
  margin-left: -20px;
}

hr {
  border: 0;
  width: 100%;
  height: 1px;
  background-image: linear-gradient(
    to right,
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 0.75),
    rgba(255, 255, 255, 0)
  );
}

.titulosmenu {
  font-weight: bold;
  color: grey;
}

/* Novos estilos para submenus e grupos */
.menu-group {
  margin-bottom: 8px;
}

.menu-group.v-list-group--active > .v-list-group__header {
  background-color: rgba(255, 255, 255, 0.1) !important;
}

.menu-group .v-list-group__header.v-list-item {
  border-radius: 8px;
  padding-left: 12px;
  transition: all 0.3s ease;
}

.menu-group .v-list-group__header.v-list-item:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.submenu-item {
  border-radius: 6px;
  margin: 2px 0 2px 10px;
  padding-left: 8px;
  transition: all 0.3s ease;
  background-color: rgba(255, 255, 255, 0.05);
}

.submenu-item:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.submenu-icon {
  color: rgba(255, 255, 255, 0.85) !important;
  font-size: 18px !important;
  transition: all 0.3s ease;
}

.submenu-title {
  color: rgba(255, 255, 255, 0.85) !important;
  font-size: 0.85rem;
  font-weight: 400;
}

.submenu-item:hover .submenu-icon,
.submenu-item:hover .submenu-title {
  color: white !important;
}

/* Item de suporte */
.menu-footer {
  padding: 16px 12px 16px 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.support-item {
  border-radius: 12px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.05));
  margin-bottom: 0;
  transition: all 0.3s ease;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
}

.support-item:hover {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0.07));
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.support-avatar {
  background: rgba(255, 255, 255, 0.2);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.support-item:hover .support-avatar {
  transform: scale(1.1);
}

/* Melhorias na sidebar */
.v-navigation-drawer {
  border-radius: 0 20px 20px 0 !important;
  overflow: hidden;
}

/* Estilos para o menu recolhido */
.v-navigation-drawer.v-navigation-drawer--mini-variant {
  width: 70px !important;
  overflow: hidden !important;
  border-radius: 0 16px 16px 0 !important;
  box-shadow: 0 4px 25px rgba(0, 0, 0, 0.15) !important;
}

.v-navigation-drawer--mini-variant .v-list-item {
  padding: 0 12px !important;
  justify-content: center !important;
  margin-bottom: 10px !important;
}

.v-navigation-drawer--mini-variant .v-list-item__action {
  margin: 6px auto !important;
}

.v-navigation-drawer--mini-variant .menu-item:hover .menu-icon {
  background: rgba(255, 255, 255, 0.15);
  transform: translateY(-3px);
  box-shadow: 0 5px 12px rgba(0, 0, 0, 0.15);
}

.v-navigation-drawer--mini-variant .menu-item-active .menu-icon {
  background: rgba(255, 255, 255, 0.2);
  box-shadow: 0 5px 12px rgba(0, 0, 0, 0.15);
}

.v-navigation-drawer--mini-variant .v-list-group__header .v-list-item__icon {
  margin: 6px auto !important;
}

.v-navigation-drawer--mini-variant .logo-container {
  padding: 12px 6px !important;
  display: flex;
  justify-content: center;
  align-items: center;
}

.v-navigation-drawer--mini-variant .logo-image {
  max-width: 32px !important;
  margin: 0 auto !important;
}

.v-navigation-drawer--mini-variant .v-list {
  padding: 8px 0 !important;
}

.v-navigation-drawer--mini-variant .menu-footer {
  padding: 12px 6px !important;
}

.v-navigation-drawer--mini-variant .support-item {
  margin: 0 auto !important;
  padding: 6px !important;
  display: flex;
  justify-content: center !important;
}

.v-navigation-drawer--mini-variant .support-avatar {
  margin: 0 auto !important;
}

.v-list-group__items .v-list-item {
  padding-left: 16px !important;
}

.v-navigation-drawer.theme--dark {
  border-right: none !important;
}

.v-navigation-drawer.v-navigation-drawer--is-mobile {
  box-shadow: 2px 0 20px rgba(0, 0, 0, 0.1) !important;
}

/* Indicador visual para item ativo no menu mini */
.v-navigation-drawer--mini-variant .menu-item-active::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 20px;
  width: 4px;
  background: white;
  border-radius: 0 4px 4px 0;
  box-shadow: 0 0 8px rgba(255, 255, 255, 0.6);
}

/* Tooltip personalizado para o menu mini */
.v-navigation-drawer--mini-variant .menu-item::after {
  content: attr(data-title);
  position: absolute;
  left: 70px;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 12px;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease;
  z-index: 99;
  white-space: nowrap;
}

.v-navigation-drawer--mini-variant .menu-item:hover::after {
  opacity: 0.9;
}

/* Transições suaves ao passar o mouse */
.v-navigation-drawer.v-navigation-drawer--mini-variant:hover {
  transition: width 0.4s cubic-bezier(0.25, 0.8, 0.5, 1) !important;
}

.v-navigation-drawer.v-navigation-drawer--mini-variant:not(:hover) {
  transition: width 0.2s cubic-bezier(0.25, 0.8, 0.5, 1) !important;
}

.v-navigation-drawer.v-navigation-drawer--mini-variant:hover .menu-icon {
  margin-right: 16px !important;
  transition: margin 0.3s ease !important;
}

.v-navigation-drawer--mini-variant:hover .v-list-item {
  padding: 0 16px 0 12px !important;
  justify-content: flex-start !important;
  margin-bottom: 4px !important;
  transition: all 0.3s ease !important;
}

.v-navigation-drawer--mini-variant:hover .v-list-item__action {
  margin: 12px !important;
  transition: margin 0.3s ease !important;
}

/* Correção para os cabeçalhos de grupo no menu recolhido */
.v-navigation-drawer--mini-variant .v-list-group__header {
  padding: 0 12px !important;
  justify-content: center !important;
}

.v-navigation-drawer--mini-variant:hover .v-list-group__header {
  padding: 0 16px !important;
  justify-content: flex-start !important;
}

.v-navigation-drawer--mini-variant .v-list-group__header .v-list-item__icon {
  margin: 6px auto !important;
}

.v-navigation-drawer--mini-variant:hover .v-list-group__header .v-list-item__icon {
  margin: 12px !important;
  transition: margin 0.3s ease !important;
}

/* Animações para o menu */
@keyframes slideInLeft {
  from {
    transform: translateX(-20px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.menu-item, .menu-group {
  animation: slideInLeft 0.3s ease-out forwards;
  animation-delay: calc(var(--index, 0) * 0.05s);
}

.menu-item:nth-child(1) { --index: 1; }
.menu-item:nth-child(2) { --index: 2; }
.menu-item:nth-child(3) { --index: 3; }
.menu-item:nth-child(4) { --index: 4; }
.menu-item:nth-child(5) { --index: 5; }
.menu-item:nth-child(6) { --index: 6; }
.menu-item:nth-child(7) { --index: 7; }
.menu-item:nth-child(8) { --index: 8; }
.menu-item:nth-child(9) { --index: 9; }
.menu-item:nth-child(10) { --index: 10; }

.imagemLogo {
  position: absolute;
  right: 50%;
  left: 50%;
  margin-right: -50px;
  margin-left: -50px;
}

.textomenu {
  font-size: 15px;
  position: absolute;
  left: 5%;
  color: white;
  /* margin-right:-50px; */
  margin-left: -20px;
}

hr {
  border: 0;
  width: 100%;
  height: 1px;
  background-image: linear-gradient(
    to right,
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 0.75),
    rgba(255, 255, 255, 0)
  );
}

.titulosmenu {
  font-weight: bold;
  color: grey;
}
</style>
